import { FC } from 'react'

import { Portal } from '@trustycars/genie-ui/components'
import { Icon } from '@trustycars/genie-ui/icons'

import BaseModal, { BaseModalContent } from '$elements/BaseModal'

import useMFABlock from '$actions/useMFABlock'

import Choice from './Choice'
import OTPBlock from '../OTPBlock'
import TOTPBlock from '../TOTPBlock'

import { closeButton, content, tryAnotherMethodButton } from './styles.css'

export type MFABlockProps = ReturnType<typeof useMFABlock>

const Block: FC<MFABlockProps> = ({
  modalProps,
  disabled,
  factorControllers: { emailOTP, smsOTP, authenticatorTOTP, larkOTP },
  data,
  hasMoreThanOneFactor,
  onSelect,
  onBack,
  selectedFactor,
  showChoices
}) => (
  <BaseModal {...modalProps}>
    <BaseModalContent className={content}>
      <button type="button" className={closeButton} onClick={onBack}>
        <Icon namespace="Backward" /> Back
      </button>

      {showChoices && (
        <Choice data={data} onClick={onSelect} disabled={disabled} />
      )}

      {selectedFactor == 'email_otp' && <OTPBlock {...emailOTP.otpBlock} />}

      {selectedFactor == 'sms_otp' && <OTPBlock {...smsOTP.otpBlock} />}

      {selectedFactor == 'lark_otp' && <OTPBlock {...larkOTP.otpBlock} />}

      {selectedFactor == 'totp' && (
        <TOTPBlock {...authenticatorTOTP.totpBlock} />
      )}

      {!showChoices && hasMoreThanOneFactor && (
        <button
          type="button"
          disabled={disabled}
          className={tryAnotherMethodButton}
          onClick={onBack}
        >
          Try another method
        </button>
      )}
    </BaseModalContent>
  </BaseModal>
)

export const MFABlock: FC<MFABlockProps> = props => (
  <Portal>
    <Block {...props} />
  </Portal>
)

export default MFABlock
